import http from './http'
import CONFIG from './config'
/**
 * 
 * eventId     true    string  事件id
   attributes  false   object  埋点额外属性
 */
// 上报工具类 不需要在外面调用, js内部使用
function ZGF_Report(params, options = {}) {
    console.log("正在上报中...");
    console.log(params);
    options.urlType = 'report'
    options.suffix = CONFIG.SUFFIX
    http.POST('reportPush', params, options)
        .then(() => {
            console.log('上报成功');
        })
        .catch(err => {
            console.log('上报失败');
            console.log(err);
        })
}


// 手机号异业合作H5
function Cooperatem_1001({ Cooperate_ID, Cooperate_Name }) {
    ZGF_Report({
        eventId: "Cooperatem_1001",
        attributes: {
            Cooperate_ID,
            Cooperate_Name
        }
    });
}

function Cooperatem_1002() {
    ZGF_Report({ eventId: "Cooperatem_1002" });
}

function Cooperatem_1003() {
    ZGF_Report({
        eventId: "Cooperatem_1003"
    });
}

function Cooperatem_1004() {
    ZGF_Report({
        eventId: "Cooperatem_1004"
    });
}

function Cooperatem_1005({ Cooperate_Name, Taost_Name }) {
    ZGF_Report({
        eventId: "Cooperatem_1005",
        attributes: {
            Cooperate_Name,
            Taost_Name
        }
    });
}
export default {
    Cooperatem_1001,
    Cooperatem_1002,
    Cooperatem_1003,
    Cooperatem_1004,
    Cooperatem_1005
};